export interface StudentIntakeRow {
  id: string;
  submitted_at: string;
  full_name: string;
  preferred_name: string | null;
  date_of_birth: string | null;
  course: string | null;
  whatsapp_e164: string | null;
  email: string | null;
  home_address_line1: string | null;
  home_address_line2: string | null;
  home_city: string | null;
  home_country: string | null;
  home_postal_code: string | null;
  dietary_tags: string[] | null;
  dietary_notes: string | null;
  allergies: string | null;
  allergy_severity: string | null;
  medical_notes: string | null;
  nok_name: string | null;
  nok_relationship: string | null;
  nok_whatsapp_e164: string | null;
  nok_email: string | null;
  nationality: string | null;
  passport_number: string | null;
  passport_expiry: string | null;
  id_photo_path: string | null;
  passport_photo_path: string | null;
  indemnity_accepted: boolean;
  indemnity_version: string;
}

const HEADERS: Array<[keyof StudentIntakeRow | "_id_url" | "_pp_url", string]> = [
  ["submitted_at", "Submitted at"],
  ["full_name", "Full name"],
  ["preferred_name", "Preferred name"],
  ["date_of_birth", "Date of birth"],
  ["course", "Course"],
  ["whatsapp_e164", "WhatsApp"],
  ["email", "Email"],
  ["home_address_line1", "Address line 1"],
  ["home_address_line2", "Address line 2"],
  ["home_city", "City"],
  ["home_country", "Country"],
  ["home_postal_code", "Postal code"],
  ["dietary_tags", "Dietary tags"],
  ["dietary_notes", "Dietary notes"],
  ["allergies", "Allergies"],
  ["allergy_severity", "Allergy severity"],
  ["medical_notes", "Medical notes"],
  ["nok_name", "Next of kin — name"],
  ["nok_relationship", "Next of kin — relationship"],
  ["nok_whatsapp_e164", "Next of kin — WhatsApp"],
  ["nok_email", "Next of kin — email"],
  ["nationality", "Nationality"],
  ["passport_number", "Passport number"],
  ["passport_expiry", "Passport expiry"],
  ["id_photo_path", "ID photo (storage path)"],
  ["passport_photo_path", "Passport photo (storage path)"],
  ["indemnity_accepted", "Indemnity accepted"],
  ["indemnity_version", "Indemnity version"],
];

function csvCell(v: unknown): string {
  if (v === null || v === undefined) return "";
  const s = Array.isArray(v) ? v.join("; ") : String(v);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function buildStudentIntakeCsv(rows: StudentIntakeRow[]): string {
  const headerLine = HEADERS.map((h) => csvCell(h[1])).join(",");
  const lines = rows.map((r) =>
    HEADERS.map(([key]) => csvCell((r as any)[key])).join(","),
  );
  return [headerLine, ...lines].join("\n");
}

export function downloadCsv(filename: string, csv: string) {
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}